import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { defaultColors, majorScale } from '../../npaper';

export interface IStatusBarProps extends BoxProps<any> {
  success?: number;
  warning?: number;
  danger?: number;
}

export const StatusBar = ({
  success = 0,
  warning = 0,
  danger = 0,
  ...props
}) => {
  return (
    <Box
      {...props}
      width="100%"
      height={majorScale(1)}
      borderRadius={majorScale(1)}
      backgroundColor={defaultColors.gray[200]}
      overflow="hidden"
      position="relative"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        height="100%"
        backgroundColor={defaultColors.red[500]}
        width={`${danger * 100}%`}
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        height="100%"
        backgroundColor={defaultColors.yellow[500]}
        width={`${warning * 100}%`}
      />
      <Box
        position="absolute"
        top={0}
        left={0}
        height="100%"
        backgroundColor={defaultColors.green[500]}
        width={`${success * 100}%`}
      />
    </Box>
  );
};
